import PersonalProjects from './PersonalProjects';

export default PersonalProjects;



// WEBPACK FOOTER //
// ./src/PersonalProjects/index.js